import React from 'react'


const projects = [
  {
    title: "TeamApp: Die ultimative Zentrale für moderne Remote-Kollaboration",
    description: "TeamApp ist eine innovative All-in-One-Plattform, die Kommunikation, Aufgabenmanagement und Terminplanung nahtlos vereint. Sie wurde speziell für moderne Remote-Teams entwickelt, um die **Produktivität** durch eine intuitive Benutzeroberfläche und **Echtzeit-Synchronisation** zu maximieren – ganz **ohne technische Barrieren**.",
    images: ["/images/team-app-webflow.png", "/images/team-blog-app.png"],
    link: "https://mesmin-team-app.webflow.io/",
    tags: ["Blog", "Webflow", "Figma"]
  },
  {
    title: "Mesmin Portfolio: Die Verbindung von modernem Design und technischer Präzision",
    description: "Dieses Projekt ist ein hochwertiges digitales Schaufenster, das auf **ergebnisorientiertes Webdesign** und eine erstklassige Nutzererfahrung setzt. Durch **nutzerzentrierte Entwicklung** und ein minimalistisches, aber wirkungsvolles Layout wird die Expertise des Entwicklers optimal präsentiert. Die Seite dient als perfektes Beispiel für **Konversionsoptimierung**, indem sie technische Kompetenz und kreative Ästhetik nahtlos miteinander verknüpft.",
    images: ["/images/mesmin-portfolio1.png", "/images/mesmin-portfolio2.png"],
    link: "https://portfolio-mesmin.webflow.io/",
    tags: ["Webflow", "Figma","HTML5 & CSS3", "JavaScript", "UI/UX"]
  },
  {
    title: "MERN Full Stack: Full-Stack-E-Commerce-Plattform & Admin-Dashboard",
    description: "Leistungsstarke E-Commerce-Anwendung mit einem vollständigen System zur sicheren Authentifizierung, Online-Zahlungsabwicklung und einem Dashboard zur Verkaufsanalyse. Reaktive Architektur mit stiller Verwaltung der Benutzersitzungen.",
    images: ["/images/blog-admin-panel-1.png", "/images/blog-admin-panel-2.png", "/images/blog-admin-panel-5.png" ],
    link: "https://kyana-shop.onrender.com/",
    tags: ["Node.js, Express", "Mongoose / MongoDB", "BcryptJS", "React 18/19, Vite", "Stripe22", "Cloudinary2 "]
  },
  {
    title: "Kimallix: Echtzeit-Kommunikation durch intelligente Web-Architektur",
    description: "Diese App ist ein Paradebeispiel für nutzerzentrierte Entwicklung im Bereich der **Echtzeit-Kollaboration**. Durch ein ergebnisorientiertes Webdesign bietet die Plattform eine **intuitive Oberfläche**, die komplexe Datenströme vereinfacht.",
    images: ["/images/Chat-app-in-Real-Time-2.png", "/images/Chat-app-in-Real-Time.png"],
    link: "https://kimallix-chatapp.onrender.com/",
    tags: ["MERN-Stack", "Socket.io", "JSON Web Tokens, Tailwind CSS"]
  },
  {
    title: "Hochperformante Echtzeit-Kommunikation mit Fullstack-Exzellenz",
    description: "Diese Anwendung ist ein Paradebeispiel für **nutzerzentrierte Entwicklung** im Bereich Messaging. Durch ein **ergebnisorientiertes Webdesign** bietet die Plattform eine intuitive Oberfläche, die Echtzeit-Interaktion mit höchster Stabilität vereint. Dank der nahtlosen Integration von Authentifizierung und Cloud-Speicher wurde eine Infrastruktur geschaffen, die nicht nur technisch überzeugt, sondern durch ihre exzellente User Experience auch die **Konversionsoptimierung** für digitale Kollaborationstools maßgeblich unterstützt.",
    images: ["/images/Chat-app-3.png", "/images/Chat-app-2.png"],
    link: "https://fullstack-chat-app-01.onrender.com/",
    tags: ["MERN-Stack", "Socket.io", "JWT", "Cloudinary", "Tailwind CSS & DaisyUI"]
  },
  {
    title: "Blog Engine Full-Stack : Next.js & Headless CMS Architecture",
    description: "Entwicklung eines modernen, ultraschnellen Blogs, der gezielt auf SEO und Nutzerinteraktion (User Engagement) optimiert wurde. Durch die Anbindung eines React-Frontends an eine GraphQL-API habe ich ein Echtzeit-Filtersystem für Kategorien sowie ein interaktives Karussell für Featured Content implementiert. Die Architektur ermöglicht sofortige Inhaltsaktualisierungen über ein Headless CMS ohne erneutes Deployment des Codes, was eine maximale Flexibilität für die redaktionelle Verwaltung bietet.",
    images: ["/images/Hygraph Blog CMS 1.png", "/images/Hygraph Blog CMS 2.png"],
    link: "https://hygraphcms-mesmin-blog.vercel.app/",
    tags: ["React.js & Next.js", "Full-Stack", "HygraphCMS"]
  }
];


const Projekte = () => {
  return (
    <div className="max-w-6xl mx-auto px-6 py-20">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16">
        {projects.map((project, index) => (
          <div key={index} className="group flex flex-col space-y-6">
            
            {/* Conteneur d'images avec effet de switch au survol */}
            <div className="relative h-[350px] md:h-[450px] overflow-hidden rounded-[2.5rem] shadow-2xl">
              {/* Image Principale */}
              <img 
                src={project.images[0]} 
                alt={project.title} 
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
              />
              {/* Image Détail (apparaît au survol) */}
              <img 
                src={project.images[1]} 
                alt={`${project.title} detail`} 
                className="absolute inset-0 w-full h-full object-cover opacity-0 group-hover:opacity-100 transition-opacity duration-500 scale-110 group-hover:scale-100"
              />
              
              {/* Badge Lien Demo */}
              <div className="absolute bottom-6 right-6 z-20">
                <a 
                  href={project.link} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="bg-white/90 backdrop-blur-sm text-secondary font-bold px-6 py-3 rounded-full flex items-center gap-2 hover:bg-primary hover:text-white transition-all duration-300"
                >
                  Live Demo <span className="text-sm">↗</span>
                </a>
              </div>
            </div>

            {/* Infos du Projet */}
            <div className="px-4 space-y-4">
              <div className="flex gap-3">
                {project.tags.map((tag, i) => (
                  <span key={i} className="text-xs font-bold text-primary tracking-widest uppercase">{tag}</span>
                ))}
              </div>
              <h3 className="text-2xl font-black text-secondary group-hover:text-primary transition-colors">
                {project.title}
              </h3>
              <p className="text-slate-600 text-lg leading-relaxed max-w-xl">
                {project.description.split('**').map((part, i) => (
                  /* Si l'index est impair, c'est que le texte était entre les astérisques */
                  i % 2 === 1 ? (
                    <strong key={i} className="text-primary font-bold">
                      {part}
                    </strong>
                  ) : (
                    /* Sinon, c'est du texte normal */
                    part
                  )
                ))}
              </p>
              <div className="w-12 h-1 bg-primary/30 group-hover:w-full transition-all duration-700 rounded-full"></div>
            </div>

          </div>
        ))}
      </div>
    </div>
  );
}

export default Projekte